module.exports = __webpack_public_path__ + "static/media/Navisworks Simulate.e4f70b0c.png";